// Nav

jQuery(document).ready(function($) {
    var el = document.querySelector('.homepage__navigation, .nav');
    window.addEventListener('scroll', function() {
        if (this.scrollY >= 100 ){
            el.classList.add('blue-nav');
        } else {
            el.classList.remove('blue-nav');
        }
    });
});

// MAP

$(document).ready(function () {
    $('.poi').hover(
        function () {
            // Au survol
            let poiId = $(this).attr('id');
            $('.insert-list').removeClass('active'); // retire la classe active de tous
            $('.insert-list[data-id="' + poiId + '"]').addClass('active');
        },
        function () {
            // À la sortie du survol
            $('.insert-list').removeClass('active');
        }
    );
});
